module.exports = __webpack_public_path__ + "img/guang.6205ea1f.png";